import {CalenderWrapper} from '@mazraeapp/react-time-calender-kit';
import moment from 'jalali-moment';
import React, {useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import './style.css';

interface ISelectedDate {
  days: string;
  month: string;
  year: string;
}
interface CalenderWrapperBottomSheetProps {
  isOpenBottomSheet: boolean;
  setIsOpenBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  addDateHandler: (value: string) => void;
}
const CalenderWrapperBottomSheet = ({
  isOpenBottomSheet,
  setIsOpenBottomSheet,
  addDateHandler,
}: CalenderWrapperBottomSheetProps) => {
  const m = moment();

  const [selectedDate, setSelectedDate] = useState<ISelectedDate>({
    days: m.locale('fa').format('DD'),
    month: m.locale('fa').format('MM'),
    year: m.locale('fa').format('YYYY'),
  });

  const changeTodayHandler = () => {
    setSelectedDate({
      days: m.locale('fa').format('DD'),
      month: m.locale('fa').format('MM'),
      year: m.locale('fa').format('YYYY'),
    });
  };
  const changeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDate(prev => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };
  return (
    <BottomSheet
      onDismiss={() => {
        setIsOpenBottomSheet(false);
      }}
      open={isOpenBottomSheet}
      blocking={true}
      className="transition ease-in-out delay-250 "
    >
      <div className="flex flex-col w-full gap-5 py-3 CalenderWrapperBottomSheet-wrapper">
        <p className="flex justify-center w-full p-0 m-0 text-lg text-gray-950 font-Regular">
          {moment(
            `${selectedDate.year}-${selectedDate.month}-${selectedDate.days}`,
            'jYYYY-jMM-jDD',
          )
            .locale('fa')
            .format('DD  jMMMM YYYY')}
        </p>
        <div className="flex justify-between w-full px-3 ">
          <CalenderWrapper
            startYear={moment().add(1, 'jYear').jYear()}
            buttonClassName="border-[1px] text-md w-full rounded-[8px] px-1 border-farm-shop-500 h-[40px] flex text-gray-800"
            buttonGroupClassName="w-full buttonGroup-wrapper flex justify-between"
            days={selectedDate.days}
            month={selectedDate.month}
            year={selectedDate.year}
            calenderType="jalali"
            onChangeCalender={changeHandler}
          />
        </div>
        <div className="flex items-center justify-between w-full px-3">
          <button
            className="border-[1px] text-sm items-center justify-center rounded-[8px] px-5 border-farm-shop-500 h-[40px] flex text-gray-800"
            onClick={() => changeTodayHandler()}
          >
            امروز
          </button>
          <div className="flex items-center justify-between gap-2">
            <button
              className="items-center text-sm text-gray-700 justify-center rounded-[8px] px-4  h-[40px] flex "
              onClick={() => {
                setIsOpenBottomSheet(false);
              }}
            >
              انصراف
            </button>
            <button
              disabled={
                !moment(
                  `${selectedDate.year}-${selectedDate.month}-${selectedDate.days}`,
                ).isValid()
              }
              className="items-center text-sm justify-center rounded-[8px] px-4  h-[40px] flex text-gray-800 disabled:text-gray-700 "
              onClick={() => {
                setIsOpenBottomSheet(false);
                addDateHandler(
                  `${selectedDate.year}-${selectedDate.month}-${selectedDate.days}`,
                );
              }}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CalenderWrapperBottomSheet;
